
export default {
  name: "FooterMenu",
};
